import { createEnv } from "@t3-oss/env-core";
import { invalidEnv } from "@typedoc/env/errors";
import { z } from "zod";
import { validateApiBase } from "../lib/rpc/transport";

const endpointSchema = z.string().refine(
  (value) => {
    try {
      validateApiBase(value);
      return true;
    } catch {
      return false;
    }
  },
  {
    message: "must be an HTTP(S) URL or root-relative path without credentials, query or fragment",
  },
);

// Better Auth appends basePath only to an absolute origin; custom paths override it.
const authOriginSchema = endpointSchema.refine((value) => /^https?:\/\/[^/\s]+\/?$/i.test(value), {
  message: "must be an absolute HTTP(S) origin without a path",
});

/** Public declarations are reusable by Vite without reading or exposing its environment. */
export function readPublicEnv(source: Record<string, string | undefined>) {
  return createEnv({
    clientPrefix: "VITE_",
    client: {
      VITE_API_URL: endpointSchema.default("/api"),
      VITE_API_URL_AU: endpointSchema.default("/api"),
      VITE_API_URL_US: endpointSchema.optional(),
      VITE_AUTH_URL: authOriginSchema.optional(),
      // Which chat service the Chats screens talk to. Unset is the in-memory sample; `live` is
      // the Chats API. A build-time choice, and nothing the app does can change it.
      VITE_CHAT_API: z.enum(["sample", "live"]).optional(),
    },
    runtimeEnvStrict: {
      VITE_API_URL: source["VITE_API_URL"],
      VITE_API_URL_AU: source["VITE_API_URL_AU"] || source["VITE_API_URL"],
      VITE_API_URL_US: source["VITE_API_URL_US"],
      VITE_AUTH_URL: source["VITE_AUTH_URL"],
      VITE_CHAT_API: source["VITE_CHAT_API"],
    },
    emptyStringAsUndefined: true,
    isServer: false,
    onValidationError: (issues) => invalidEnv("web", issues),
  });
}
